import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return (filter) => {
    return present(
      repository
        .getUnavailabilities(filter)
        .then((unavailabilities) => ({ filter, unavailabilities }))
        .catch(() => Promise.reject(filter)),
    );
  };
}

export type { Interactor };

export { createInteractor };
